// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__22NxA","error":"Textarea_error__1IhHl","readonly":"Textarea_readonly__2WRB7","disabled":"Textarea_disabled__3b5bj"};